module.exports = __webpack_public_path__ + "static/Kaizer-90a51143a9b220d507ae6014685bb2b9.png";